import {
  ACCOUNT_SERVICE,
  API_VERSION,
  X_API_VERSION,
} from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_BANK_ACCOUNTS = `${ACCOUNT_SERVICE}/bank-accounts`;

export const bankAccounts = {
  getFromQuickBooks: async () => {
    const options = await apiOptions({
      url: `${API_BANK_ACCOUNTS}`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options);
  },
  //this is from our db not from quickbooks
  getAll: async () => {
    const options = await apiOptions({
      url: `${API_BANK_ACCOUNTS}/payments`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options);
  },
  approve: async ({ data, modifiedOn, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_BANK_ACCOUNTS}`,
      method: "post",
      data,
      modifiedOn,
      headers: { [X_API_VERSION]: API_VERSION },
      toastMessageConfig,
    });
    return apiRequest(options);
  },
  remove: async ({ id, modifiedOn, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_BANK_ACCOUNTS}/bankAccountQboId`,
      method: "delete",
      modifiedOn,
      params: { bankAccountQboId: id },
      headers: { [X_API_VERSION]: API_VERSION },
      toastMessageConfig,
    });
    return apiRequest(options);
  },
};
